import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    inspeccion: {},

};
const mutations = {
    updateField,
    updateInspeccion: (state, payload) => {
        state.inspeccion = payload;
    },
};
const getters = {
    getField,
};
export default {
    namespaced: true,
    state,
    mutations,
    getters
}
